import styled, { useTheme } from 'styled-components'
import miniheaderImageLight from './miniheader-light.png'
import miniheaderImageDark from './miniheader-dark.png'

const MiniHeader = () => {
  const theme = useTheme()

  return (
    <Picture>
      {/* <source
        media='(prefers-color-scheme: light)'
        srcSet={miniheaderImageLight}
      />
      <source
        media='(prefers-color-scheme: dark)'
        srcSet={miniheaderImageDark}
      /> */}
      <img
        src={
          theme.colorMode === 'dark'
            ? miniheaderImageDark
            : miniheaderImageLight
        }
        alt='Logo de Bilan 300 plus riches 2024'
      />
    </Picture>
  )
}

const Picture = styled.picture`
  display: block;
  width: 100%;
  position: relative;

  img {
    width: 100%;
    height: auto;
  }
`

export default MiniHeader
